/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { container, title } from "assets/jss/material-kit-pro-react.jsx";
import { pageContent, fullPageContent } from "assets/jss/views/apricot.jsx";
import { niceScrollbar } from "assets/jss/views/classroomPage/classroomStyle.jsx";

export const mainImg = require("assets/img/landing.jpg");

// export const hideScrollbar = {
//   "*::-webkit-scrollbar": {
//     display: "none",
//   },
// };

const carosItem = {
  "@media (orientation: portrait)": {
    minWidth: "80vw",
    maxWidth: "80vw",
    minHeight: "45vw",
  },
  minWidth: "40vw",
  maxWidth: "40vw",
  minHeight: "22.5vw",
  width: "100%",
};

const landingPageStyle = (theme) => {
  const title = { ...title, fontFamily: theme.typography.fontFamily };

  return {
    "@global": niceScrollbar,

    container: {
      color: "#FFFFFF",
      ...container,
      zIndex: "2",
      "& h1, h2": { fontFamily: "Raleway" },
      "@media  (orientation: portrait)": {
        marginTop: "-8rem",
      },
      marginTop: "-3rem",
    },

    carosItem,

    catch: {
      textAlign: "left",
      marginBottom: "1rem",
      "& h1": {
        "@media (min-width: 768px)": {
          fontSize: "5rem",
        },
        "@media (min-width: 1440px)": {
          fontSize: "6rem",
        },
        fontSize: "4rem",
        fontWeight: 500,
        marginBottom: 0,
      },
      "& h2": {
        "@media (min-width: 768px)": {
          fontSize: "3rem",
        },
        "@media (min-width: 1440px)": {
          fontSize: "4rem",
        },
        fontSize: "2rem",
        fontWeight: 500,
        marginTop: 0,
      },
      "& h3": {
        "@media (min-width: 768px)": {
          fontSize: "1.8rem",
        },
        "@media (min-width: 1440px)": {
          fontSize: "2rem",
        },
        fontSize: "1.2rem",
      },
    },

    cardBody: {
      "@media (min-width: 600px)": {
        width: "100%",
      },
      width: "80vw",
    },

    subtitle: {
      fontSize: "1.313rem",
      maxWidth: "500px",
      margin: "10px auto 0",
    },

    pageContent,
    fullPageContent,

    block: {
      color: "inherit",
      padding: "0.9375rem",
      fontWeight: "500",
      fontSize: "12px",
      textTransform: "uppercase",
      borderRadius: "3px",
      textDecoration: "none",
      position: "relative",
      display: "block",
    },
    inlineBlock: {
      display: "inline-block",
      padding: "0px",
      width: "auto",
    },
    list: {
      marginBottom: "0",
      padding: "0",
      marginTop: "0",
    },
    left: {
      float: "left!important",
      display: "block",
    },
    right: {
      padding: "15px 0",
      margin: "0",
      float: "right",
    },
    icon: {
      width: "18px",
      height: "18px",
      top: "3px",
      position: "relative",
    },

    shareContainer: {
      verticalAlign: "middle",
      padding: "1rem",
      backgroundColor: theme.palette.primary.light,
    },

    shareItem: {
      verticalAlign: "middle",
      display: "inline-block",
      margin: "auto",
    },

    shareButton: {
      cursor: "pointer",
      margin: "0.25rem",
      "&:hover": {
        opacity: 0.75,
      },
    },
  };
};

export default landingPageStyle;
